import { env } from "~/env";
import customFetch from "../fetch/custom";

const baseUrl = env.NEXT_PUBLIC_SUPPORT_SERVICE_URL;

export const postSupport = async (param: {
  name: string;
  email: string;
  subject: string;
  message: string;
}) => {
  return customFetch<string>(`${baseUrl}/callback/support-ticket-visitors`, {
    name: "post support",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(param),
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
    getResultData: (result) => result?.message,
  });
};
